export const userRoutes = [
  {
    path: '/usuarios',
    name: 'Users',
    meta: {
      requiresAuth: true,
      menu: true,
      navbarActions: true,
      chat: true
    },
    component: () => import(/* webpackChunkName: 'users-page' */ 'views/UsersPage')
  }
]
